import { Business } from "@mui/icons-material";

export const formOptions = {
    yesNo: ['Yes', 'No'],
    projectLeads: ['John Doe', 'Jane Smith', 'Alice Johnson'],
    stakeholderGroups: ['Advertising & Marketing', 'Commercial', 'Communications', 'Control', 'Design', 'E-Commerce', 'Finance', 'Global Operations',  'HR', 'Insights', 'Legal', 'M&A', 'Procurement','R&D', 'S&T', 'Sustainability','Supply Chain', 'Tax', ],
    financeLeads: ['David Brown', 'Sara White', 'Tom Harris'],
    sectors: ['AMESA', 'APAC', 'Corporate', 'Europe', 'Global', 'LATAM', 'PBNA', 'PFNA', 'PGCS'],
    consultingTypes: ['Specialized Consulting', 'Strategic/Management Consulting'],
    costRanges: ['< $10,000', '$10,000 - $50,000', '$50,000 - $100,000', '> $100,000'],
    rating : ['Exceptional', 'Good', 'Fair', 'Poor'],
    classification : ['Restricted', 'Confidential', 'Internal'],
  };
  
  export const intakeAutoPopulatedFields = {
    requestedBy: 'John Doe',
    location: 'New York Office',
    manager: 'Jane Smith',
    email: 'john.doe@example.com',
  }
  
  export const autoPopulatedFields = {
    requestedBy: 'John Doe',
    location: 'New York Office',
    manager: 'Jane Smith',
    email: 'john.doe@example.com',
    financeEmail: 'david.brown@finance.com',
    business_stakeholder : 'S & T',
    cost_center : 'New York',
    sector : 'Finance',
    geographic_scope : 'North America',
    contract_extension : 'Yes',
    project_name : 'Sales Forecasting',
    Project_brief : 'Sales Forecasting Description',
    consulting_type : 'Specialized Consulting',
    start_date : '23-08-2022',
    end_data : '30-10-2024',
    use_others : 'Yes',
    Preferred_vendor : 'Tiger Analytics',
    core_deliverables : 'GPT web app',
    service_cost : ' $50,000-$100,000',
    follow_up : 'Yes'
  };
  
  export const closeoutAutoPopulatedFields = {
    capability : 'No',
    bandwidth : 'No',
    benchmarking : 'No',
    extension : 'Yes',
    requestedBy: 'John Doe',
    location: 'New York Office',
    manager: 'Jane Smith',
    email: 'john.doe@example.com',
    financeEmail: 'david.brown@finance.com',
    projectLead : 'John Doe',
    stakeHolderRequestingGroup : 'Operations',
    financeLead : 'David Brown',
    sector : 'Technology',
    consultingType : 'Advisory',
    costRange : '$10,000 - $50,000',
    rating : 'Fair',
    business_stakeholder : 'S & T'
  }
  